import React, {useState} from "react"
import {Box, Button, Tab, Tabs, Typography} from "@mui/material"
import PropTypes from "prop-types"
import Content from "../../../anwendungskonfigurator/components/Content"
import {cloneAndReplace, getMerkmal} from "../../misc/widget-functions"
import AddIcon from "@mui/icons-material/Add"

const ContainerFlexTab = ({ container, getDataFromPointer, disabled, triggerAction }) => {
    const [activeTab, setActiveTab] = useState(0)

    const data = getDataFromPointer(getMerkmal(container)?.pointer)
    const entries = Array.isArray(data) ? data : []

    const singleItem = container.singleItem !== false

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
    }

    const safeActiveTab = activeTab >= entries.length && entries.length > 0 ? entries.length - 1 : activeTab

    if (singleItem) {
        const dataEntry = entries[0] ?? {}
        const displayedContainers = container?.children?.map((entry) => cloneAndReplace(entry, 0))
        return (
            <Box width="100%">
                <Box role="tabpanel" id="tabpanel-0" sx={{ pt: 2 }}>
                    {displayedContainers?.map((child) => (
                        <Content
                            key={child.id}
                            child={child}
                            disabled={disabled}
                            payload={dataEntry}
                        />
                    ))}
                </Box>
            </Box>
        )
    }

    return (
        <Box width="100%">
            <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", alignItems: "center" }}>
                {entries.length > 0 && (
                    <Tabs
                        value={safeActiveTab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="Container tabs"
                    >
                        {entries.map((dataEntry, index) => {
                            const label = container.tabname ? `${container.tabname} ${index + 1}` : `Tab ${index + 1}`
                            return (
                                <Tab
                                    key={dataEntry?.id || index}
                                    label={label}
                                    id={`tab-${index}`}
                                    aria-controls={`tabpanel-${index}`}
                                />
                            )
                        })}
                    </Tabs>
                )}
                <Button
                    onClick={() => triggerAction(container.addAction)}
                    aria-label="Add entry"
                    sx={{ ml: entries.length === 0 ? 0 : 1 }}
                >
                    <AddIcon color="primary" />
                </Button>
            </Box>

            {entries.length === 0 ? (
                <Box sx={{ p: 3, textAlign: "center" }}>
                    <Typography color="text.secondary">Keine Einträge vorhanden. '+' anklicken, um einen anzulegen.</Typography>
                </Box>
            ) : (
                entries.map((dataEntry, index) => {
                    const displayedContainers = container?.children?.map((entry) =>
                        cloneAndReplace(entry, index)
                    )

                    return (
                        index === safeActiveTab && (
                            <Box
                                key={dataEntry?.id || index}
                                role="tabpanel"
                                id={`tabpanel-${index}`}
                                aria-labelledby={`tab-${index}`}
                                sx={{ pt: 2 }}
                            >
                                {displayedContainers?.map((child) => (
                                    <Content
                                        key={child.id}
                                        child={child}
                                        disabled={disabled}
                                        payload={dataEntry}
                                    />
                                ))}
                            </Box>
                        )
                    )
                })
            )}
        </Box>
    )
}

ContainerFlexTab.propTypes = {
    container: PropTypes.shape({
        tabname: PropTypes.string,
        children: PropTypes.array,
        singleItem: PropTypes.bool,
    }),
    getDataFromPointer: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default ContainerFlexTab